import { TypeScriptUtils } from "../../utils";
import { RuleDataUtils } from '../RuleData';
export const getSourceFullNames = (sources, ruleData) => {
    return sources
        .map((sourceMapping) => RuleDataUtils.getSourceDataInfo(sourceMapping.sourceId, ruleData))
        .map((source) => source === null || source === void 0 ? void 0 : source.description)
        .filter(TypeScriptUtils.isNotNullOrUndefined);
};
